import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    formRow: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 20,
      gap: 20,
      '&:last-child': {
        marginBottom: 0,
      },
    },
  }),
);

export default useStyles;
